import app from '#/app';

/**
 * Created by erez on 17/09/14.
 * @namespace app.validate
 */

const validate = {
  url: function (url) {
    url = url.trim();
    // return /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.\-=\?&]*)*\/?$/i.test(url);
    // return url.indexOf(' ') == -1 &&
    // eslint-disable-next-line max-len
    //  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(url);
    const re_weburl = new RegExp(
      '^' +
        // protocol identifier
        '(?:(?:https?:)?//)?' +
        // user:pass authentication
        '(?:\\S+(?::\\S*)?@)?' +
        '(?:' +
        // IP address exclusion
        // private & local networks
        '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
        '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
        '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
        // IP address dotted notation octets
        // excludes loopback network 0.0.0.0
        // excludes reserved space >= 224.0.0.0
        // excludes network & broacast addresses
        // (first & last IP address of each class)
        '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
        '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
        '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
        '|' +
        // host name
        '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
        // domain name
        '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
        // TLD identifier
        '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
        // TLD may end with dot
        '\\.?' +
        ')' +
        // port number
        '(?::\\d{2,5})?' +
        // resource path
        '(?:[/?#]\\S*)?' +
        '$',
      'i'
    );
    return url.indexOf(' ') == -1 && re_weburl.test(url);
  },

  youtubeUrl: function (url) {
    return this.url(url) && /youtube\.com/i.test(url);
  },

  email: function (email) {
    // eslint-disable-next-line no-useless-escape
    return /^([a-z0-9 \.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/i.test(email);
  },

  /**
   * @param duration {Number}
   * @param maxDurationDescriptor {StoryModel|Number}
   * @return {boolean}
   */
  storyDuration: function (duration, maxDurationDescriptor) {
    let maxDuration = null;
    if (maxDurationDescriptor instanceof Backbone.Model) {
      maxDuration = maxDurationDescriptor
        .getProgrammer()
        .get('maxStoryDuration');
    } else if (_.isNumber(maxDurationDescriptor)) {
      maxDuration = maxDurationDescriptor;
    }

    // if `duration` still unknown - assume valid
    return _.isDefined(duration) ? app.sfp(duration, 1e3) <= maxDuration : true;
  },

  /**
   * @param duration {Number}
   * @param storyModel {StoryModel}
   * @return {boolean}
   */
  storyDurationSoft: function (duration, storyModel) {
    const maxDuration = storyModel.getProgrammer().get('maxStoryDuration');
    const softMaxDuration = storyModel
      .getProgrammer()
      .get('storySoftMaxDuration');

    // if `duration` still unknown - assume valid
    return _.isDefined(duration) && _.isDefined(softMaxDuration)
      ? !(
          app.sfp(duration, 1e3) >= softMaxDuration &&
          app.sfp(duration, 1e3) <= maxDuration
        )
      : true;
  },

  /**
   * validate user configuration
   */
  userIsValid: function () {
    const state = {
      valid: true,
      title: 'User configuration issue',
      description: [],
    };

    if (_.isEmpty(tk.context.relatedProgrammerList)) {
      state.valid = false;
      state.description.push(
        'Current user should be associated with at least one brand'
      );
    }

    if (!state.valid) {
      app.delayedSpinner.hide();
      app.dialog
        .error({
          type: app.dialog.types.ERROR_1,
          title: state.title,
          description: state.description.join('<br/>'),
          showContactCsm: true,
        })
        .then(() => {
          app.rootStore.dispatch('user/logout');
        });
    }

    return state.valid;
  },
};

export default validate;
